import React from "react"

export default function Bullet() {
  return (
    <div>
      <div className="mt-0.5 mr-1.5 w-0.75 h-2.5 transform -skew-x-22.5 bg-socialiePink" />
    </div>
  )
}
